/** @format */

// import {filter} from 'lodash';
import React, { useState, useEffect } from "react";
// material
import {
  Button,
  Card,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
  CircularProgress,
} from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchToolbar from "../../reusables/table/SearchToolbar";
import SortableTableHeader from "../../reusables/table/SortableTableHeader";
//
// import NumberMoreMenu from "./NumberMoreMenu";
import { useNavigate } from "react-router-dom";
import Iconify from "../../components/Iconify";
import {
  applySortFilter,
  getComparator,
} from "../../reusables/table/SortFilterUtils";
import SearchNotFound from "../../components/SearchNotFound";
// import TableMenuDropdown from "../../reusables/table/TableMenuDropdown";
// import TableMenuItem from "../../reusables/table/TableMenuItem";
import PhoneNumber from "../../dao/PhoneNumber";
import Waba from "../../dao/Waba";
import Select from "react-select";
import swal from "../../reusables/CustomSwal";

import qs from "qs";
import { useLocation } from "react-router";
import { blacklistUser } from "../../static/blacklist";
import { useSelector } from "react-redux";

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "count", label: "No.", alignRight: false },
  { id: "phone_num", label: "Phone Broadcast", alignRight: false },
  { id: "verified_name", label: "Verified Name", alignRight: false },
  { id: "quality_rating", label: "Quality Rating", alignRight: false },
  { id: "limit", label: "Limit", alignRight: false },
  { id: "config", label: "Configured", alignRight: false },
];

const TABLE_HEAD_BLACKLIST = [
  { id: "count", label: "No.", alignRight: false },
  { id: "phone_num", label: "Phone Broadcast", alignRight: false },
  { id: "verified_name", label: "Verified Name", alignRight: false },
];

// ----------------------------------------------------------------------
export default function Number(props) {
  const navigate = useNavigate();
  const location = useLocation();
  let email = useSelector(({ auth }) => auth?.auth?.email);
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  let idParam = queryParams.waba_id;

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("F");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [numbers, setNumbers] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(false);

  const [wabaOptions, setWabaOptions] = useState([]);
  const [selectedWabaId, setSelectedWabaId] = useState(null);
  const [selectedWabaLabel, setSelectedWabaLabel] = useState(null);

  const getPhoneNumbers = async () => {
    try {
      navigate("?waba_id=" + selectedWabaId);

      let result = await PhoneNumber.getAll(selectedWabaId);
      // console.log(result);
      setNumbers(result);
      setIsDataFetched(true);
    } catch (e) {
      console.log("ERROR", e);
      await swal.fire({
        title: "Error",
        text: "An error has occurred. Please try again later.",
        icon: "error",
      });
    }
  };

  const getWabas = async () => {
    try {
      let result = await Waba.getMyWaba();
      // console.log(result);
      //let templates = result.map((el) => ({...el.profile, role: el.role}));

      let formatted = result.map((obj) => {
        return {
          label: `${obj.name} (${obj.waba_id})`,
          value: obj.waba_id,
        };
      });

      if (formatted.length > 0) {
        let wabaFromParam = formatted.find((obj) => obj.value === idParam);

        if (wabaFromParam && idParam) {
          setSelectedWabaId(wabaFromParam.value);
          setSelectedWabaLabel(wabaFromParam.label);
        } else {
          setSelectedWabaId(formatted[0].value);
          setSelectedWabaLabel(formatted[0].label);
        }
      }

      setWabaOptions(formatted);
    } catch (e) {
      // nothing
    }
  };

  useEffect(() => {
    getWabas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // console.log("UE", selectedWabaId);
    if (selectedWabaId !== null) {
      getPhoneNumbers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWabaId]);

  let count = page * rowsPerPage + 1;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    count = page * rowsPerPage + 1;
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  //   const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage) : 0;
  const filteredData = applySortFilter(
    numbers,
    getComparator(order, orderBy),
    filterName,
    "phone_num"
  );
  const notFound = filteredData.length === 0;

  const checkBlackList = !blacklistUser.some((item) => item === email);

  return (
    <Page title="WhatsApp Numbers">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            WhatsApp Numbers
          </Typography>
        </Stack>

        <Stack
          style={{
            marginBottom: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          direction="row"
        >
          <small>Filter by Waba ID :</small>
          <div style={{ width: 300 }}>
            <Select
              onChange={(option) => {
                // console.log(option);
                setSelectedWabaId(option.value);
                setSelectedWabaLabel(option.label);
              }}
              value={{
                label: selectedWabaLabel,
                value: selectedWabaId,
              }}
              options={wabaOptions}
            />
          </div>
        </Stack>

        {wabaOptions.length > 0 && (
          <Card>
            <SearchToolbar
              filterName={filterName}
              onFilterName={handleFilterByName}
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table style={{ backgroundColor: "white", color: "white" }}>
                  <SortableTableHeader
                    order={order}
                    orderBy={orderBy}
                    headLabel={
                      checkBlackList ? TABLE_HEAD : TABLE_HEAD_BLACKLIST
                    }
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => {
                        const {
                          id,
                          display_phone_number,
                          verified_name,

                          quality_rating,
                          limit,

                          config,
                        } = row;
                        // const phoneNum = display_phone_number.replace(
                        //   /\D/g,
                        //   ""
                        // );
                        return (
                          <TableRow
                            hover
                            key={row.id}
                            tabIndex={-1}
                            role="checkbox"
                          >
                            <TableCell align="left">{count++}</TableCell>
                            <TableCell align="left">
                              {display_phone_number}
                            </TableCell>
                            <TableCell align="left">{verified_name}</TableCell>
                            {checkBlackList && (
                              <>
                                <TableCell align="left">
                                  <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems="center"
                                  >
                                    <Iconify
                                      icon="akar-icons:circle-fill"
                                      height={10}
                                      sx={{
                                        color:
                                          quality_rating === "GREEN"
                                            ? "#57d95a"
                                            : quality_rating === "YELLOW"
                                            ? "#ffd70e"
                                            : quality_rating === "RED"
                                            ? "#d90e0e"
                                            : "#727272",
                                      }}
                                    />
                                    <Typography variant="p">
                                      {quality_rating}
                                    </Typography>
                                  </Stack>
                                </TableCell>
                                <TableCell align="left">{limit}</TableCell>
                                <TableCell align="left">
                                  {config ? "Configured" : "Not Configured"}
                                </TableCell>
                              </>
                            )}
                            <TableCell align="right">
                              <Button
                                onClick={() => {
                                  navigate(
                                    `/number/manage/${selectedWabaId}/${id}`
                                  );
                                }}
                                variant={"outlined"}
                                style={{ textDecoration: "none" }}
                              >
                                Detail
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    {/*{emptyRows > 0 && (*/}
                    {/*  <TableRow style={{height: 53 * emptyRows}}>*/}
                    {/*    <TableCell colSpan={6}/>*/}
                    {/*  </TableRow>*/}
                    {/*)}*/}
                  </TableBody>
                  {(notFound || !isDataFetched) && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          {!isDataFetched ? (
                            <CircularProgress />
                          ) : (
                            <SearchNotFound searchQuery={filterName} />
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[10, 20, 50, 100]}
              component="div"
              count={numbers.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        )}
      </Container>
    </Page>
  );
}
